var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (
    this.getProfile &&
      this.getProfile.isAdmin &&
      this.tournament &&
      this.tournament.reward &&
      this.tournament.currentRound > this.tournament.totalRounds
  )?_c('button',{staticClass:"button is-success is-small",on:{"click":_vm.rewardPlayers}},[_vm._v("\n  Reward Players\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }